import { Skeleton } from 'antd';

export const renderSkeleton = () => {
    return (
      <>
        <div className='flex gap-1'>
          <Skeleton.Input active={true} size={'small'} />
          <Skeleton.Input active={true} size={'small'} />
        </div>
        <div className='flex gap-1'>
          <Skeleton.Input active={true} size={'small'} />
          <Skeleton.Input active={true} size={'small'} />
        </div>
      </>
    );
  };
